<template>
    <div class="container-table2">
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th v-for="(column, index) in columns" :key="column">
                            <div class="column-header" :id="column">
                                <span>{{ column }}</span>
                                <b-button v-b-tooltip.hover  class="btn-transparent" v-if="tooltips && tooltips[index]" :title="tooltips[index]">
                                    <img                         
                                        src="@/assets/img/icons/information-circle-gray.svg"
                                        class="info-icon"
                                        alt=""
                                    />
                                </b-button>


                                
                            </div>
                            
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" :key="index" v-if="rows.length > 0">
                        <td v-for="column in columns" :key="column + index">
                            <a v-if="links && links[column]" :href="links[column](row)" class="link-table" target="_blank">{{ row[column] }}</a>
                            <template v-else>
                                {{ row[column] }}
                            </template>
                        </td>
                    </tr>
                    <tr style="border-width: 0;" v-if="!rows || rows.length == 0">
                        <td :colspan="columns.length" class="no-data">Não existem dados disponíveis.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "Table",
    props: ["filter", "columns", "rows", "links", "tooltips"],
};
</script>

<style scoped>
    .column-header{
        flex-direction: row;
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        align-items: center;
        gap: 2px;
    }
    .no-data {
        color: #4B5563;
        text-align: center;  
        padding: 44px 0px 44px 0px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .container-table2 {
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
    }
    .table-responsive {
        width: 100%;
        overflow-x: auto;
    }
    .link-table {
        color: var(--Default-primary-800, #0854C5);

        /* text-sm/leading-5/font-medium */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    th {
        background-color: #F3F4F6;
        color: #475467;
        font-size: 13px;
        line-height: 18px;
        font-family: Inter;
        font-weight: 500;
        text-align: left;
        white-space: normal;
    }
    
    th .column-header span {
        color: #475467;
    }
    
    th, td {
        padding: 8px 8px;
        border: none;
    }
    td {
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    tr:not(:last-child) {
        border-bottom: 1px solid #EAECF0;
    }
    .info-icon {
        color: #475467;
        width: 16px;
        height: 16px;
    }

    .btn-transparent {
      background-color: transparent;
      border: 1px solid transparent;
      padding: 0;
      width: auto;
      height: auto;
    }
    
    .btn-transparent:hover {
        background-color: transparent;
        border: 1px solid transparent;
    }
</style>
